module.exports = __webpack_public_path__ + "img/SFJ0001-1.f8bac3e5.jpg";